import React, { useState, useMemo } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import WarrantyPeriodTable from './components/WarrantyPeriodTable';
import WarrantyPeriodForm from './components/WarrantyPeriodForm';
import useWarrantyPeriodData from './hooks/useWarrantyPeriodData';
import GenericTableFilter from '../../../../components/common/GenericTableFilter';
import { useLanguage } from '../../../../contexts/LanguageContext';

const WarrantyPeriodPage = () => {
    const { th } = useLanguage();
    const [selectedItem, setSelectedItem] = useState(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const toast = React.useRef(null);
    const [isEdit, setIsEdit] = useState(false);

    const { warrantyPeriodApi, isLoading, lazyParams, onPage, saveWarrantyPeriod, activeFilters, handleFilterChange, initFilters } = useWarrantyPeriodData();

    const handleEdit = (rowData) => {
        setSelectedItem(rowData);
        setDialogVisible(true);
    };

    const handleHide = () => {
        setDialogVisible(false);
        setSelectedItem(null);
    };

    const handleSubmit = async (formData) => {
        const success = await saveWarrantyPeriod(formData);
        if (success) {
            handleHide();
        }
    };

    const filterFields = useMemo(
        () => [
            { field: 'carItemCode', headerName: th('vehicleWarrantyPeriod.filterFields.carItemCode'), type: 'text' },
            { field: 'productGroup', headerName: th('vehicleWarrantyPeriod.filterFields.productGroup'), type: 'text' },
            { field: 'startDate', headerName: th('vehicleWarrantyPeriod.filterFields.startDate'), type: 'date' },
            { field: 'endDate', headerName: th('vehicleWarrantyPeriod.filterFields.endDate'), type: 'date' }
        ],
        [th]
    );

    const handleCreateClick = (formData) => {
        setIsEdit(false);
        setSelectedItem(null);
        setDialogVisible(true);
    };

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4"></div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleWarrantyPeriod.title')}</h1>
                <Button label={th('vehicleWarrantyPeriod.newButton')} icon="pi pi-plus" onClick={handleCreateClick} />
            </div>
            <div className="mb-2">
                <GenericTableFilter filterFields={filterFields} initialFilters={{}} onSearch={() => {}} onApplyFilters={handleFilterChange} onResetFilters={initFilters} />
            </div>
            <WarrantyPeriodTable data={warrantyPeriodApi} totalCount={warrantyPeriodApi?.totalCount} loading={isLoading} lazyParams={lazyParams} onPage={onPage} onEdit={handleEdit} />
            {<WarrantyPeriodForm visible={dialogVisible} onHide={handleHide} onSubmit={handleSubmit} initialData={selectedItem} loading={isLoading} />}
        </div>
    );
};

export default WarrantyPeriodPage;
